import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mx-auto px-40 xl:w-4/5" }
const _hoisted_2 = ["innerHTML"]

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { computed } from 'vue';
import dictionaryService from '@/core/dictionary/dictionary.service';
import { useRouteQuery } from '@/core/browser/route-query.composable';
import { QueryKeys } from '@/shared/config/route-query.config';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReceiptConfirmation',
  setup(__props) {

const labels = useBlockLabels();
const id = useRouteQuery(QueryKeys.Id);

const confirmationText = computed<string>(() => {
    const names = {
        orderNumber: id.value,
    };
    return dictionaryService.formatNamed(labels.confirmationText, names);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "o-anim-fade-300",
    mode: "out-in",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "o-rte-magic-line-links",
          innerHTML: _unref(confirmationText)
        }, null, 8, _hoisted_2)
      ])
    ]),
    _: 1
  }))
}
}

})